export default "__VITE_PUBLIC_ASSET__37915008__"